// Unpublished Work © 2021-2022 Deere & Company

import {
    RESET_SELECT_BUSINESS_CONTACT,
    SET_SELECT_BUSINESS_CONTACT_DATA
} from '../../action-list';
import {Customer} from '../../state/struct/customer';

const setContactData = (state, action) => action.selectBusinessContact.contacts.map((contact) => Customer(contact));

const resetBusinessContactProfile = () => [];

export const contacts = (state = [], action = {}) => {
    const actionHandlers = {
        [RESET_SELECT_BUSINESS_CONTACT]: resetBusinessContactProfile,
        [SET_SELECT_BUSINESS_CONTACT_DATA]: setContactData
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
